import { Button } from './Button'
import { Container } from './Container'
import { Dropdown, DropdownLinkItem } from './Dropdown'
import { GeorgeButton } from './GeorgeButton'

export const FollowUpButtons = {
  Container,
  Button,
  Dropdown,
  DropdownLinkItem,
  GeorgeButton
}
